import { useState, useEffect, ReactNode } from 'react';

import { styled } from '@mui/system';
import IconButtonMui from '@mui/material/IconButton';
import TooltipMui, { TooltipProps, tooltipClasses } from '@mui/material/Tooltip';

import ClickAwayListener from '@mui/material/ClickAwayListener';

import { ReactComponent as IcTakeQuestions } from 'assets/icons/ic-take-questions.svg';

type Params = {
    children: ReactNode;
}

const TooltipMuiCustom = styled(({ className, ...props }: TooltipProps) => (
    <TooltipMui {...props} classes={{ popper: className }} />
))(({ theme }) => ({
    [`& .${tooltipClasses.tooltip}`]: {
        maxWidth: '12rem',
        padding: '.75rem 1rem',
        backgroundColor: '#061C45',
        boxShadow: '2px 2px 3px rgba(0, 0, 0, 0.25)',

        // eslint-disable-next-line no-useless-computed-key
        ['span']: {
            color: '#061C45',
        }
    },
}));

const IconButton = styled(IconButtonMui)(`
    padding: 0px;
    margin: 0px 0px 2px 4px;
`);

const Tooltip = ({ children }: Params) => {
    const [open, setOpen] = useState(false);
    const [isMobile, setIsMobile] = useState(false)

    const handleTooltipClose = () => {
        setOpen(false);
    };

    const handleTooltipOpen = () => {
        setOpen(true);
    };


    const handleResize = () => {
        if (window.innerWidth < 720) {
            setIsMobile(true)
        } else {
            setIsMobile(false)
        }
    }

    useEffect(() => {
        handleResize();
        window.addEventListener("resize", handleResize);
    });

    return (
        isMobile ? (
            <ClickAwayListener onClickAway={handleTooltipClose}>
                <div style={{ display: 'contents' }}>
                    <TooltipMuiCustom
                        arrow
                        placement="top"
                        title={children}
                        PopperProps={{
                            disablePortal: true,
                        }}
                        onClose={handleTooltipClose}
                        open={open}
                        disableFocusListener
                        disableHoverListener
                        disableTouchListener>
                        <IconButton onClick={handleTooltipOpen}>
                            <IcTakeQuestions />
                        </IconButton>
                    </TooltipMuiCustom>
                </div>
            </ClickAwayListener>
        ) : (
            <TooltipMuiCustom arrow placement="top" title={children}>
                <IconButton>
                    <IcTakeQuestions />
                </IconButton>
            </TooltipMuiCustom>
        )
    );
}

export default Tooltip;